import { c as _c } from "react/compiler-runtime";
import PrettyJsonVisualizer from '@/components/pretty-json-visualizer';
type TextContentViewerProps = {
  text: string;
  mimeType: string | null;
};
const isJsonString = (text: string): boolean => {
  try {
    JSON.parse(text);
    return true;
  } catch {
    return false;
  }
};
const TextContentViewer = t0 => {
  const $ = _c(6);
  const {
    text,
    mimeType
  } = t0;
  let t1;
  if ($[0] !== mimeType || $[1] !== text) {
    t1 = mimeType === "application/json" || isJsonString(text);
    $[0] = mimeType;
    $[1] = text;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isJson = t1;
  let t2;
  if ($[3] !== isJson || $[4] !== text) {
    t2 = <div className="h-full w-full overflow-auto p-6"><div className="border border-solid border-tertiary rounded-lg p-4 bg-primary">{isJson ? <PrettyJsonVisualizer json={text} /> : <pre className="text-body-2 text-primary whitespace-pre-wrap break-words font-mono">{text}</pre>}</div></div>;
    $[3] = isJson;
    $[4] = text;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default TextContentViewer;